<script lang="ts">
  import { GalleryGrid, GalleryAutoscrolling } from './components/gallery';
  import type {
    GlobalProperties,
    UseFormattedProps,
  } from 'customer-components/lib/types';

  export let properties: UseFormattedProps;
  export let settings: GlobalProperties;
  // todo: where is this page coming from?
  export let page;

  $: ({ headingFont } = settings);
</script>

{#if properties}
  <div
    class="gallery-container"
    style="background:var(--vlt-lp-background);color:var(--vlt-lp-text);"
    id={properties?.anchor}
  >
    {#if properties.style === 'Grid'}
      <GalleryGrid
        images={properties.images}
        heading={properties.heading}
        {headingFont}
        objectFit={properties.contain}
        rounded={properties.roundedCorners}
      />
    {:else}
      <GalleryAutoscrolling
        {page}
        images={properties.images}
        heading={properties.heading}
        rounded={properties.roundedCorners}
        objectFit={properties.contain}
      />
    {/if}
  </div>
{/if}

<style>
  .gallery-container {
    padding-top: 50px;
    padding-bottom: 50px;
  }
</style>
